import { useCallback, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { adminApi, errMsg, fmtDateTime } from "@/lib/api";
import { toast } from "sonner";

// Admin Master → Sistema: cópia de segurança diária do banco para o Atlas do responsável (plano de continuidade).
export function BackupAtlasBox() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => adminApi.get("/backup/atlas").then((r) => setS(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const agora = async () => {
    setBusy(true);
    try { const { data } = await adminApi.post("/backup/atlas/agora"); toast.success(data.mensagem); setTimeout(load, 15000); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!s) return null;
  const boa = s.ultima_boa;
  const ult = s.ultimo;
  return (
    <div className="sm:col-span-2 space-y-2 rounded-lg border p-4" data-testid="backup-atlas-box">
      <p className="font-semibold">Cópia de segurança (MongoDB Atlas)</p>
      {s.alerta && <p className="rounded-md bg-amber-500/10 px-3 py-2 text-sm text-amber-700 dark:text-amber-300" data-testid="backup-alerta">{s.alerta}</p>}
      {boa && <p className="text-sm">Última cópia boa: <b>{fmtDateTime(boa.fim)}</b> · {boa.colecoes} coleções · {boa.documentos} documentos · {boa.tamanho_mb} MB · {boa.slot}
        {" · "}<span data-testid="backup-consistencia">{boa.consistencia === "snapshot" ? "snapshot: todas as coleções do mesmo instante" : "verificada: conferida no fim da cópia (não é de um instante único)"}</span>
        {boa.mudaram_durante_copia?.length > 0 && ` (mudaram durante a cópia: ${boa.mudaram_durante_copia.join(", ")})`}
        {boa.espaco && <span data-testid="backup-espaco">{` · Atlas: ${boa.espaco.uso_antes_mb} MB usados antes da cópia, capacidade ${boa.espaco.capacidade_mb} MB`}</span>}</p>}
      {ult && !ult.ok && <p className="text-sm text-red-600">Última tentativa falhou: {ult.motivo}</p>}
      <p className="text-xs text-muted-foreground">Roda todo dia às 3h. A produção continua no Emergent; esta é só uma cópia, para recuperar o sistema em outro servidor se precisar.
        {!s.configurado && " Para ligar, crie o segredo ATLAS_BACKUP_URL no servidor (nunca pelo chat)."}</p>
      <Button size="sm" variant="outline" disabled={busy || !s.configurado} onClick={agora} data-testid="backup-agora-btn">Fazer uma cópia agora</Button>
    </div>
  );
}
